module.exports = __webpack_public_path__ + "img/tringle-header.c42f80d8.svg";